import { ca } from '@cian/analytics';

interface ITrackAnswerButtonClickArgs {
  objectId: number;
  rating: number;
  reviewsCount: number;
  reviewId: string;
}

export const trackAnswerButtonClick = ({ objectId, rating, reviewsCount, reviewId }: ITrackAnswerButtonClickArgs) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'DailyrentReviews',
    action: 'Click_sopr',
    label: 'Reply',
    page: { extra: { rating, reviewsCount, reviewId } },
    products: [{ id: objectId, offerType: 'offer' }],
  });
};
